import React, { useState, useEffect } from 'react';
import { MessageSquare, Clock } from 'lucide-react';

export const MessageHistory = ({ quoteId }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, [quoteId]);

  const fetchMessages = async () => {
    try {
      const apiUrl = window.location.origin;
      const token = localStorage.getItem('admin_token');

      const response = await fetch(`${apiUrl}/api/quotes/${quoteId}/messages`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setMessages(data);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des messages:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="text-sm text-gray-500 italic">Chargement de l'historique...</div>
    );
  }

  if (messages.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic">Aucun message envoyé pour cette demande</div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center space-x-2 text-sm font-semibold text-gray-700 mb-3">
        <MessageSquare size={16} />
        <span>Historique des messages ({messages.length})</span>
      </div>
      
      <div className="space-y-2">
        {messages.map((msg) => (
          <div key={msg.id} className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <div className="flex justify-between items-start mb-2">
              <p className="font-semibold text-blue-900 text-sm">{msg.subject}</p>
              <div className="flex items-center text-xs text-gray-600">
                <Clock size={12} className="mr-1" />
                {formatDate(msg.timestamp)}
              </div>
            </div>
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{msg.message}</p>
            <div className="mt-2 text-xs text-gray-500">
              Envoyé à : <span className="font-medium">{msg.sent_to}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
